<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ColorGrid',
  setup() {
    const colors = [
      [
        {
          name: 'white',
          hex: 'bg-[#fff]',
          link: '/colors/white-candy/',
        },
        {
          name: 'cream',
          hex: 'bg-[#FAF5E9]',
          link: '/colors/cream-candy/',
        },
      ],
      [
        {
          name: 'black',
          hex: 'bg-[#000]',
          link: '/colors/black-candy/',
        },
        {
          name: 'silver',
          hex: 'bg-[#D9D9D9]',
          link: '/colors/silver-candy/',
        },
      ],
      [
        {
          name: 'blue',
          hex: 'bg-[#43A2D8]',
          link: '/colors/blue-candy/',
        },
        {
          name: 'light',
          hex: 'bg-[#9BBDEF]',
          link: '/colors/light-blue-candy/',
        },
        {
          name: 'dark',
          hex: 'bg-[#1A4684]',
          link: '/colors/dark-blue-candy/',
        },
      ],
      [
        {
          name: 'purple',
          hex: 'bg-[#BE85C9]',
          link: '/colors/purple-candy/',
        },
        {
          name: 'lilac',
          hex: 'bg-[#A696BD]',
          link: '/colors/lilac-candy/',
        },
        {
          name: 'lavender',
          hex: 'bg-[#5E366C]',
          link: '/colors/lavender-candy/',
        },
      ],
      [
        {
          name: 'pink',
          hex: 'bg-[#FAA5C7]',
          link: '/colors/pink-candy/',
        },
        {
          name: 'hot',
          hex: 'bg-[#F63668]',
          link: '/colors/hot-pink-candy/',
        },
        {
          name: 'light',
          hex: 'bg-[#FBBAD8]',
          link: '/colors/light-pink-candy/',
        },
      ],
      [
        {
          name: 'green',
          hex: 'bg-[#8AC82C]',
          link: '/colors/green-candy/',
        },
        {
          name: 'light',
          hex: 'bg-[#AAE16C]',
          link: '/colors/light-green-candy/',
        },
        {
          name: 'pastel',
          hex: 'bg-[#99E1B8]',
          link: '/colors/pastel-green-candy/',
        },
      ],
      [
        {
          name: 'yellow',
          hex: 'bg-[#F1BE22]',
          link: '/colors/yellow-candy/',
        },
        {
          name: 'vibrant',
          hex: 'bg-[#F2E750]',
          link: '/colors/vibrant-yellow-candy/',
        },
        {
          name: 'pastel',
          hex: 'bg-[#DFE271]',
          link: '/colors/pastel-yellow-candy/',
        },
      ],
      [
        {
          name: 'orange',
          hex: 'bg-[#F2661A]',
          link: '/colors/orange-candy/',
        },
        {
          name: 'peach',
          hex: 'bg-[#F69864]',
          link: '/colors/peach-candy/',
        },
        {
          name: 'gold',
          hex: 'bg-[#DFB745]',
          link: '/colors/gold-candy/',
        },
      ],
      [
        {
          name: 'red',
          hex: 'bg-[#C70035]',
          link: '/colors/red-candy/',
        },
        {
          name: 'brown',
          hex: 'bg-[#724D0F]',
          link: '/brown-candy/',
        },
        {
          name: 'rainbow',
          img: 'https://nuts.com/images/test/department/wedding/color/wedding-candy-colors-assorted.gif',
          link: '/colors/rainbow-candy/',
        },
      ],
    ];

    return {
      colors,
    };
  },
});
</script>

<template>
  <div class="flex">
    <div class="dynamic-content color-grid w-full my-5">
      <div class="flex-col w-full col" v-for="(col, i) in colors" :key="i">
        <RouterLink
          v-for="(color, k) in col"
          class="button-color flex border border-solid border-gray text-sm justify-center my-1 py-1.5"
          :to="color.link"
          :class="[
            color.hex,
            { rainbow: color.img },
            { 'ml-2.5': i > 0 },
            { white: i === 0 && k === 0 },
            { cream: i === 0 && k === 1 },
          ]"
          :key="`${i} - ${color.name}`"
          >{{ color.name }}
        </RouterLink>
      </div>
    </div>
  </div>
</template>